module.exports = __webpack_public_path__ + "static/media/segovia.0d11c35c.jpg";